export const GET_CART = '/carts/postcode/';
export const APPLY_DISCOUNT = '/orders/apply_discount/';
export const ADD_TO_CART = '/carts/';
export const GET_LOGOUT_INVOICE = '/carts/guest/invoice/postcode/';
export const CREATE_STRONGHOLD = '/strong_hold/customer';
export const GET_WALLET_WITH_PURCHASE_REWARDS = '/carts/tier_rewards';
export const GET_WALLET_WITH_PURCHASE_REWARDS_GUEST = '/carts/guest/tier_rewards';
